import { FormControlProps } from '@mui/material/FormControl';
import { ReactElement } from 'react';
import { Control, Controller, FieldErrors, FieldValues, Path } from 'react-hook-form';
import get from 'lodash/get';
import { generalDate } from '~/ui/constants/dateFormat';
import DatePickerMUI, { LegacyDateView } from './DatePickerMUI';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  name: string;
  minDate?: string;
  maxDate?: string;
  referenceDate?: Date;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  dateFormat?: string;
  openTo?: LegacyDateView;
  size?: FormControlProps['size'];
  tabIndex?: number;
  className?: string;
  views?: LegacyDateView[];
  clearable?: boolean;
  cb?: (value: Date) => void;
}

const DatePickerComponent = <TFieldValues extends FieldValues = FieldValues>({
  control,
  errors,
  name,
  minDate,
  maxDate,
  referenceDate,
  openTo = 'year',
  label = '',
  placeholder = '',
  disabled = false,
  dateFormat = generalDate,
  size = 'small',
  views = ['year', 'month', 'date'],
  tabIndex,
  className,
  clearable,
  cb,
}: IProps<TFieldValues>): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field: { value, onChange } }) => (
        <DatePickerMUI
          size={size}
          label={label}
          error={error as string}
          openTo={openTo}
          views={views}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat={dateFormat}
          value={value as Date | string}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          className={className}
          tabIndex={tabIndex}
          clearable={clearable}
          cb={cb}
          muiProps={referenceDate ? { referenceDate } : undefined}
        />
      )}
    />
  );
};

export default DatePickerComponent;
